import Typography from "../Typography/Typography";
import styles from "./Button.module.scss";

const Button = (props) => {
	const {
		children,
		onClick,
		type = "",
		style,
		className = "",
		color = "",
		disabled = false,
	} = props;

	return (
		<button
			className={`${styles.buttonContainer} ${
				color === "white" ? styles.whiteVariant : null
			} ${className}`}
			onClick={onClick}
			style={style}
			type={type}
			disabled={disabled}
		>
			<Typography
				color={color === "white" ? "primary" : "white"}
				variant="h5"
			>
				{children}
			</Typography>
		</button>
	);
};

export default Button;
